module.exports = __webpack_public_path__ + "static/img/multimedia1.4b7d9bf9.png";